module.exports = __webpack_public_path__ + "static/media/cbon.7bd4a4d3.jpeg";